import React from 'react';

const FormCheckbox = ({ id, name, label, value, inputRef = null, onChange = null, className = null, disabled = false}) => {
    return (
        <div className={`${className}`}>
            <label htmlFor={id} className='flex gap-2 items-center font-medium'>
                <span className={`mr-2 w-[28px] h-[28px] flex-none rounded-full border-2 flex items-center justify-center ${!disabled ? 'border-purple': 'border-grey'}`}>
                    <input id={id} type="checkbox" name={name} 
                        className={`w-[12px] h-[12px] rounded-full border-none text-white focus:ring-0 ${!disabled ? 'checked:bg-none checked:text-purple': ''}`}
                        defaultChecked={value}
                        onChange={onChange}
                        ref={inputRef} />
                </span>
                {label}
            </label>
        </div>
    );
};

export default FormCheckbox;